import React, { useContext } from "react";
import { EndosoContext } from "pages/endoso/context";
import { NuevoTextoForm } from "./components/form";
import { PdfPreview24 } from "./components/pdfPreview";

export const NuevoTexto24 = () => {
  const { continueR24 } = useContext(EndosoContext);
  return continueR24 ? <PdfPreview24 /> : <NuevoTextoForm />;
};
